import Logo from './images/circle.png'

export default function footer() {
    const year = new Date().getFullYear();
    return (
        <>
            <div className='footerShow'>
                <div className="footerWrapper">
                    <div className='footerInner'>
                        <div className='row'>
                            <div className='col-12 col-sm-4'>
                                <div className='footerTxtLeft'>
                                    <p><strong>Siège social</strong></p>
                                    <p>2407-199, rue de la Rotonde</p>
                                    <p>Verdun</p>
                                    <p>QC H3E 0C1</p>
                                    <p className='footerTxt'>
                                        &#xa9; ALGEGO {year}
                                    </p>
                                </div>
                            </div>
                            <div className='col-12 col-sm-4'>
                                <div id='footerLogo'>
                                    <a href='/home'>
                                        <img src={Logo} alt='Logo ALGEGO'></img>
                                    </a>
                                </div>
                            </div>
                            <div className='col-12 col-sm-4'>
                                <div className='footerTxtRight'>
                                    <p><strong>Bureaux</strong></p>
                                    <p>368, rue Notre Dame O.</p>
                                    <p>Montréal</p>
                                    <p>QC H2Y 1T9</p>
                                    <p><a style={{color:'white'}} href='mailto:info@algego.com'>info@algego.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='footerHide'>
                <div className="footerWrapper">
                    <div className='footerInner'>
                        <div className='row'>
                            <div className='col-12 col-sm-4'>
                                <div className='footerTxtLeft'>
                                    <p><strong>Siège social</strong></p>
                                    <p>2407-199 rue de la Rotonde</p>
                                    <p>Verdun</p>
                                    <p>QC H3E 0C1</p>
                                </div>
                            </div>
                            <div className='col-12 col-sm-4'>
                                <div className='footerTxtRight'>
                                    <p><strong>Bureaux</strong></p>
                                    <p>368, rue Notre Dame O.</p>
                                    <p>Montréal</p>
                                    <p>QC H2Y 1T9</p>
                                    <p><a style={{color:'white'}} href='mailto:info@algego.com'>info@algego.com</a></p>
                                    <p>&#xa0;</p>
                                </div>
                            </div>
                            <div className='col-12 col-sm-4'>
                                <div id='footerLogo'>
                                    <a href='/home'>
                                        <img src={Logo} alt='Logo ALGEGO'></img>
                                    </a>
                                </div>
                                <div className='footerTxt'>
                                    &#xa9; ALGEGO {year}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
